import $ from 'jquery';
import Swiper from 'swiper';

/**
 * Initialize Vertical Tabs Swiper (both desktop and mobile)
 */
export function initVerticalTabsSwiper() {
	// Desktop vertical tabs
	$('.vertical-desktop .swiper').each(function () {
		const $swiper = $(this);
		const swiperId = $swiper.attr('id');
		const $tabsContainer = $swiper.closest('.tabs-module-wrapper');
		const uniqueId = $tabsContainer.attr('id')?.replace('tabs-layout-', '') || swiperId;

		if (swiperId && $tabsContainer.length) {
			const tabTitles = $tabsContainer.data('tab-titles') || [];

			new Swiper(`.vertical-desktop #${swiperId}`, {
				speed: 1,
				slidesPerView: 1,
				pagination: {
					el: `.vertical-desktop #tabs-layout-${uniqueId} .swiper-custom-pagination`,
					clickable: true,
					renderBullet: function (index, className) {
						const tabTitle = tabTitles[index] || `Tab ${index + 1}`;
						return `<button class="tabs-module-link ${className}" role="tab" id="${uniqueId}-tab-${index}" aria-selected="${index === 0 ? 'true' : 'false'}" aria-controls="${uniqueId}-panel-${index}" tabindex="${index === 0 ? '0' : '-1'}">${tabTitle}</button>`;
					},
				},
				allowTouchMove: false,
				breakpoints: {
					320: {
						navigation: {
							nextEl: `.vertical-desktop .${uniqueId}-swiper-button-next`,
							prevEl: `.vertical-desktop .${uniqueId}-swiper-button-prev`,
						},
					},
					1024: {
						navigation: {
							enabled: false,
						},
					},
				},
			});

			// Set uniform height for tab content
			function setUniformHeight() {
				let maxHeight = 0;
				$(`.${uniqueId}-content`).each(function () {
					const height = $(this).outerHeight();
					if (height > maxHeight) {
						maxHeight = height;
					}
				});
				$(`.${uniqueId}-content`).css('min-height', maxHeight + 'px');
			}

			$(window).on('resize', setUniformHeight);
		}
	});

	// Mobile vertical tabs
	$('.vertical-mobile .swiper').each(function () {
		const $swiper = $(this);
		const swiperId = $swiper.attr('id');
		const $tabsContainer = $swiper.closest('.vertical-mobile').find('.tabs-module-wrapper');
		const uniqueId = $tabsContainer.attr('id')?.replace('tabs-layout-', '') || swiperId;
		const $swiperHeader = $tabsContainer.find('.swiper-header');
		const $paginationContainer = $tabsContainer.find('.swiper-custom-pagination');

		if (swiperId && $tabsContainer.length) {
			const tabTitles = $tabsContainer.data('tab-titles') || [];

			new Swiper(`.vertical-mobile #${swiperId}`, {
				effect: 'fade',
				fadeEffect: {
					crossFade: true,
				},
				speed: 1,
				slidesPerView: 1,
				allowTouchMove: false,
				pagination: {
					el: `.vertical-mobile #tabs-layout-${uniqueId} .swiper-custom-pagination`,
					clickable: true,
					renderBullet: function (index, className) {
						const tabTitle = tabTitles[index] || `Tab ${index + 1}`;
						return `<button class="tabs-module-link ${className}" role="tab" id="${uniqueId}-mobile-tab-${index}" aria-selected="${index === 0 ? 'true' : 'false'}" aria-controls="${uniqueId}-mobile-panel-${index}" tabindex="${index === 0 ? '0' : '-1'}">${tabTitle}</button>`;
					},
				},
				navigation: {
					nextEl: `.vertical-mobile .${uniqueId}-swiper-button-next`,
					prevEl: `.vertical-mobile .${uniqueId}-swiper-button-prev`,
				},
				breakpoints: {
					320: {
						autoHeight: true,
					},
				},
				on: {
					init: function () {
						$swiperHeader.css('transition', 'transform 0.2s ease-in-out');
						const firstBullet = $paginationContainer.find('.swiper-pagination-bullet:first-child')[0];
						if (firstBullet) {
							$swiperHeader.css('transform', `translateX(${-firstBullet.offsetLeft}px)`);
						}
					},
					slideChange: function () {
						const activeBullet = $paginationContainer.find('.swiper-pagination-bullet-active')[0];
						if (activeBullet) {
							$swiperHeader.css('transform', `translateX(${-activeBullet.offsetLeft}px)`);
						}
					},
				},
			});
		}
	});
}
